import { icons } from '../../assets/icons/icons';
import { ClickToCallStyles } from './click-to-call-styles';

export interface IClickToCall {
  telefono: string;
  onClick: any;
}

const ClickToCall: React.FC<IClickToCall> = ({ telefono, onClick }) => {
  return (
    <ClickToCallStyles>
      <div onClick={onClick} title={telefono} className="clicktocall">
        <img src={icons.phoneIcon} alt="" />
      </div>
    </ClickToCallStyles>
  );
};

export default ClickToCall;
